import React from 'react';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'; 
import Button from '@mui/material/Button'; 
import Card from '@mui/material/Card'; 
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import SettingsIcon from '@mui/icons-material/Settings';
import Typography from '@mui/material/Typography'; 
import 'react-toastify/dist/ReactToastify.css'  
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/homeDashboardBlue.css";
import PropTypes from 'prop-types';
import image1 from "components/photos/form.jpg";
import image2 from "components/photos/finishedform.jpg";
import image3 from "components/photos/endform.jpg"; 
import image4 from "components/photos/convertpdf.png"; 
import image5 from "components/photos/Pesada.webp"; 
import image6 from "components/photos/purchase.png"; 
import image7 from "components/photos/purchaseended.jpeg"; 
import image8 from "components/photos/Sign.jpg"; 
import image9 from "components/photos/sidebars/portill.jpeg";  
import image10 from "components/photos/sidebars/portbillended.jpeg"; 
import image11 from "components/photos/sidebars/notificactions.jpeg";
import image12 from "components/photos/sidebars/notifiactionsview.jpeg";
import image13 from "components/photos/contract.jpg"; 
import image14 from "components/photos/sidebars/resolution.png";   
import image15 from "components/photos/sidebars/shippingpending.jpeg";


const data = [{
  "id": 8,
  "title": "Text_TITLE_PURCHASES_SIGN",
  "information":"Text_INFORMATION_PURCHASES_SIGN",
  "icon":image8,
  "isEnabled":true
 },{
  "id": 11,
  "title": "Text_TITLE_CREATE_NOTIFICATIONS",
  "information":"Text_INFORMATION_CREATE_NOTIFICATIONS",
  "icon":image11,
  "isEnabled":true
},{
  "id": 12,
  "title": "Text_TITLE_MODIFIED_NOTIFICATIONS",
  "information":"Text_INFORMATION_MODIFIEDNOTIFICATIONS",
  "icon":image12,
  "isEnabled":true
},{
  "id": 9,
  "title": "Text_TITLE_CREATE_SHIPPING",
  "information":"Text_INFORMATION_CREATE_SHIPPING",
  "icon":image9,
  "isEnabled":true
},{
  "id": 10,
  "title": "Text_TITLE_MODIFIED_SHIPPING",
  "information":"Text_INFORMATION_MODIFIEDSHIPPING",
  "icon":image15,
  "isEnabled":true
},{
  "id": 15,
  "title": "Text_TITLE_MODIFIED_SHIPPING_ENDED",
  "information":"Text_INFORMATION_MODIFIEDSHIPPING_ENDED",
  "icon":image10,
  "isEnabled":true
},{
  "id": 13,
  "title": "Text_TITLE_MODIFIED_CONTRACT",
  "information":"Text_INFORMATIONCONTRACT",
  "icon":image13,
  "isEnabled":true
},{
  "id": 1,
  "title": "Text_TITLE_CREATE_FORM",
  "information":"Text_INFORMATION_CREATE_FORM",
  "icon":image1,
  "isEnabled":true
},{
  "id": 2,
  "title": "Text_TITLE_FINISHED_FORM",
  "information":"Text_INFORMATION_FINISHED_FORM",
  "icon":image2,
  "isEnabled":true
},{
  "id": 3,
  "title": "Text_TITLE_MODIFIED_FORM",
  "information":"Text_INFORMATION_MODIFIED_FORM",
  "icon":image3,
  "isEnabled":true
},{
  "id": 4,
  "title": "Text_TITLE_SCAN_FORM",
  "information":"Text_INFORMATION_SCAN_FORM",
  "icon":image4,
  "isEnabled":true
 },{
  "id": 5,
  "title": "Text_TITLE_WEIGHVEHICLES",
  "information":"Text_INFORMATION_SWEIGHVEHICLES",
  "icon":image5,
  "isEnabled":true
 },{
  "id": 6,
  "title": "Text_TITLE_PURCHASES",
  "information":"Text_INFORMATION_PURCHASES",
  "icon":image6,
  "isEnabled":true
 },{
  "id": 7,
  "title": "Text_TITLE_PURCHASES_ENDED",
  "information":"Text_INFORMATION_PURCHASES_ENDED",
  "icon":image7,
  "isEnabled":true
 },{
  "id": 14,
  "title": "Text_TITLE_CREATE_INCIDENTS",
  "information":"Text_INFORMATIONINCIDENTS",
  "icon":image14,
  "isEnabled":true
}]

const PrincipalMenuSettings = ({ 
  showPrincipalMenu,
  setIndexShowSettings,
  setShowModalGeneralSettings,
  setShowPrincipalMenu
}) => {

  const {t} = useTranslation(['listDataGeneralSettings']); 
  const roles = useSelector((state) => state.loginUser.roles); 
  const displayOrder = [1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 9, 10, 15, 13, 14];
  data.forEach((item) => {
    const permissionById = {
      1: 'SubMenu_Form_Create', 2: 'SubMenu_Form_Edit', 3: 'SubMenu_Form_Edit_Ended',
      5: 'SubMenu_Tickets_Create', 6: 'SubMenu_Purchases_Create', 7: 'SubMenu_Purchases_View_Ended',
      8: 'SubMenu_Purchases_Signature_Desk', 9: 'SubMenu_Shipping_View_Init',
      10: 'SubMenu_Shipping_View_Init', 11: 'SubMenu_NT_View_Init',
      12: 'SubMenu_NT_View_Ended_Init', 13: 'SubMenu_Contract_View_Init',
      14: 'SubMenu_Incident_Create', 15: 'SubMenu_Shipping_View_Ended_Init'
    };
    item.isEnabled = item.id === 4 ? false : Boolean(roles[0].listmenus.find((menu) => menu.name === permissionById[item.id]));
  });
 

  const navigate = useNavigate();

  const closeModal = (id) => {
    switch (id) {
      case 1:    
        navigate("/formdetail/0");  
        break;
      case 2:    
        navigate("/formdi");  
        break;
      case 3:    
        navigate("/formdiended");  
        break;
      case 4:    
        setIndexShowSettings(18);
        setShowModalGeneralSettings(false);
        setShowPrincipalMenu(false);
        break;
      case 5:    
        navigate("/tickets");  
        break; 
      case 6:    
        navigate("/purchasedeliverybegin");  
        break; 
      case 7:    
        navigate("/purchasedeliveryended");  
        break; 
      case 8:    
        navigate("/purchasesignature");  
        break; 
      case 9:    
        navigate("/shippingdetailhome/0");  
        break;
      case 10:    
        navigate("/shipping");  
        break;
      case 11:    
        navigate("/ntdetailhome/0");  
        break;
      case 12:    
        navigate("/nthome");  
        break;
      case 13:    
        navigate("/contract");  
        break;
      case 14:    
        navigate("/sentincidentemail/0");  
        break;
      case 15:
        navigate("/shippingended");
        break;
 
      default:
        break;
    }
   
  };
   
  return (
    <>
      {showPrincipalMenu ? (     
        //* Begin Page Content *//
       <div className="main-dashboard-container">
          {/* Search input */}
          <h1 className="dashboard-title">
            <SettingsIcon /> {t('Text_MENU_PRINCIPAL')}
          </h1>        
          <Grid container spacing={4} className="dashboard-grid">
            {[...data].sort((a, b) => displayOrder.indexOf(a.id) - displayOrder.indexOf(b.id)).map((post) => (
              post.isEnabled && (
                <Grid item xs={12} sm={6} md={4} key={post.id}>
                  <Card className="menu-card" onClick={() => closeModal(post.id)}>
                    <CardMedia image={post.icon} title={t(post.title)} />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div" align="center">
                        {t(post.title)}
                      </Typography>
                      <Typography variant="body2" align="center">
                        {t(post.information)}
                      </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                      <Button>{t('Text_Select')}</Button>
                    </CardActions>
                  </Card>
                </Grid>
              )
            ))}
          </Grid>
        </div> 
        //* End Page Content *//
      ) :  null }
    </>
  );
};

PrincipalMenuSettings.propTypes = { 
  showPrincipalMenu: PropTypes.bool.isRequired,
  setIndexShowSettings: PropTypes.func.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired,
  setShowPrincipalMenu: PropTypes.func.isRequired
};

export default PrincipalMenuSettings;
